import api from '../services/api';
import { IDentalTreatmentItem } from '../shared/interfaces';

export const postDentalTreatmentItem = async (
  payload: any,
): Promise<IDentalTreatmentItem> => {
  const response = await api.post('/dental-treatments-items', payload);
  return response.data;
};

export const patchDentalTreatmentItem = async (
  id: string | undefined,
  payload: any,
): Promise<IDentalTreatmentItem> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.patch(`/dental-treatments-items/${id}`, payload);
  return response.data;
};

export const deleteDentalTreatmentItem = async (
  id: string | undefined,
): Promise<IDentalTreatmentItem> => {
  if (!id) {
    throw new Error('ID do item não fornecido.');
  }
  const response = await api.delete(`/dental-treatments-items/${id}`);
  return response.data;
};
